module.exports = __webpack_public_path__ + "img/biography.f45fd5b6.svg";